<template>
	<modal :id="ref" :ref="ref" :closeProp="close" title="Guida all'Implementazione" large>
		<h6>File di Verifica</h6>
		<p>Scarica il file di verifica e copialo nella cartella principale del dominio (o sottodominio). Il file non deve essere posizionato in sottocartelle.</p>

        <br>
        <h6>Foglio di Stile</h6>
		<p>
			Copia e incolla il seguente foglio di stile <code>&lt;link&gt;</code> dentro il tuo
			<code>&lt;head&gt;</code> della pagina prima di caricare gli altri fogli di stile, per
			caricare il nostro.
		</p>
		<form-input
			value='<link rel="stylesheet" type="text/css" href="https://sync.aism.it/aismform/style.css">'
			readonly
		></form-input>

		<h6>Javascript</h6>
		<p>
			Copia e incolla il seguente script JS <code>&lt;script&gt;</code> dentro il tuo
			<code>&lt;head&gt;</code> della pagina.
		</p>
		<form-input
			value='<script src="https://sync.aism.it/aismform/payments.js" type="text/javascript"></script>'
			readonly
		></form-input>

		<h6>Form</h6>
		<p>
			Copia e incolla il seguente codice nel posto in cui vuoi mostrare il form. Ricordati che
			potrai user il tuo foglio di stile per adattarlo al tuo sito.
		</p>
		<form-input :value="value" readonly></form-input>

		<h6>Thank You Page</h6>
		<p>
			Se nella tua Source è collegata una pagine dentro il campo <b>Success URL</b>, e vuoi
			insere un form, oltre ai Fogli di Stile e Javascript! Dovrai inserire anche il seguente
			codice.
		</p>
		<form-input value='<div class="aism-uniform" data-thx="true"></div>' readonly></form-input>

		<br />

		<h6>Esempio</h6>
		<form-textarea
			value='<!DOCTYPE html>
			<html lang="it">
			<head>
				<title>Esempio</title>

				<link rel="stylesheet" type="text/css" href="https://sync.aism.it/aismform/style.css">
				<script src="https://sync.aism.it/aismform/payments.js" type="text/javascript"></script>
			</head>
			<body>
				<div id="IL TUO ID" class="aism-uniform" data-source="IL TUO CODICE"></div>
			</body>
			</html>'
			readonly
		></form-textarea>
	</modal>
</template>

<script>
export default {
	data: () => ({
		ref: 'payments_type',
	}),
	props: {
		formCode: {
			type: String,
			default: '',
			required: true,
		},
	},
	computed: {
		value: function() {
			return '<div class="aism-uniform" data-source="' + this.formCode + '"></div>'
		},
	},
	methods: {
		close: function() {
			this.$refs[this.ref].close()
		},
		open: function(data) {
			this.$refs[this.ref].open()
		},
	},
}
</script>
